import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import FeaturedGrid from './components/FeaturedGrid';
import ContentSection from './components/ContentSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebSite" data={{
        name: '久久影视',
        url: 'https://jiujiuys.com',
        description: '久久影视同步最新电视剧更新与最新电影上映，影视更新快，新剧综艺抢先看，高清流畅不缓冲，追剧党首选。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://jiujiuys.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }} />
      <SchemaOrg type="Organization" data={{
        name: '久久影视',
        url: 'https://jiujiuys.com',
        description: '久久影视是国内领先的影视资讯聚合平台，提供最新电视剧更新、最新电影上映和最新综艺在线服务。',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-888-9999',
          contactType: 'customer service',
          availableLanguage: 'Chinese',
        },
      }} />
      <SchemaOrg type="FAQPage" data={{
        mainEntity: [
          { '@type': 'Question', name: '久久影视需要注册会员才能观看吗？', acceptedAnswer: { '@type': 'Answer', text: '久久影视是一个影视资讯聚合平台，我们提供最新电视剧更新、最新电影上映的信息和导航。部分内容可免费浏览，注册会员后可享受更多个性化推荐和观影记录同步等高级功能。' } },
          { '@type': 'Question', name: '久久影视的影视更新速度快吗？', acceptedAnswer: { '@type': 'Answer', text: '我们的影视更新速度非常快！久久影视同步最新电视剧更新与最新电影上映，通常在各大平台更新后的第一时间同步信息。新剧综艺抢先看，让您不错过任何精彩内容。' } },
          { '@type': 'Question', name: '久久影视支持哪些设备观看？', acceptedAnswer: { '@type': 'Answer', text: '久久影视支持全平台访问，包括PC端网页、手机浏览器、平板电脑等。我们采用自适应设计，无论您使用什么设备，都能获得高清流畅不缓冲的观影体验。' } },
          { '@type': 'Question', name: '久久影视的视频画质如何？', acceptedAnswer: { '@type': 'Answer', text: '久久影视致力于提供高清流畅的观影体验，大部分内容支持1080P高清画质，部分热门影视作品更提供4K超清选项。' } },
        ],
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />

          <CategoryTabs />

          <FeaturedGrid />

          <ContentSection />

          <FAQSection />

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-primary-500">
            <div className="max-w-[1280px] mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                追剧不等待，久久影视与您同行
              </h2>
              <p className="text-background-50/80 text-sm md:text-base mb-6 max-w-2xl mx-auto">
                最新电视剧更新、最新电影上映 —— 影视更新快，新剧抢先看，高清流畅不缓冲
              </p>
              <div className="flex items-center justify-center gap-3 flex-col sm:flex-row">
                <a href="#" className="px-6 py-3 bg-background-50 hover:bg-background-100 text-primary-600 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer">
                  立即体验
                </a>
                <a href="#" className="px-6 py-3 bg-primary-600 hover:bg-primary-700 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer">
                  了解更多
                </a>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}